/**
 * @generated SignedSource<<4b8fb1d796406083646eb6d5c0ef46a0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_user" | "PdpRespSharedAboutItemPanel_user" | "PdpRespShippingReturns_user" | "PdpRespTabsCustomizationPanel_user" | "PdpSharedBuyerIncentives_user">;
  readonly " $fragmentType": "PdpRespDetailTabs_user";
};
export type PdpRespDetailTabs_user$key = {
  readonly " $data"?: PdpRespDetailTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedAboutItemPanel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTabsCustomizationPanel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c7583e4e2d12edd5e137a9debdb51c18";

export default node;
